import { CSSProperties, useMemo } from "react";
import { Link } from "react-router";
import { TournamentSummary } from "../../types/tournamentTypes";
import { useAppSelector } from "../../state/store";

interface Props {
  pageId?: string;
  secondaryId?: string;
  text?: React.ReactNode;
  fallbackContent?: string;
  className?: string;
  style?: CSSProperties;
  navigateState?: object;
}

/**
 * Links to either another tournament page, or an external URL
 */
export function TournamentLink(props: Props) {
  const { deadLinksHome, deadLinksPage } = useAppSelector(
    (state) => state.tournaments
  );
  const deadLinksSet = useMemo(
    () => new Set([...deadLinksHome, ...deadLinksPage]),
    [deadLinksHome, deadLinksPage]
  );
  if (!props.pageId) return <span>{props.fallbackContent || null}</span>;

  const isExternal = props.pageId.includes("www.");
  const pageIdStr = `${props.pageId}${
    props.secondaryId ? `/${props.secondaryId}` : ""
  }`;
  const isDead = deadLinksSet.has(pageIdStr) && !isExternal;
  const className = props.className
    ? props.className
    : isDead
      ? "empty-link"
      : undefined;
  const text = props.text
    ? props.text
    : `${props.pageId}${props.secondaryId ? ` ${props.secondaryId}` : ""}`;

  if (isExternal) {
    return (
      <a
        href={`//${props.pageId}`}
        style={props.style}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
      </a>
    );
  }

  const getLinkTo = () => {
    if (!props.pageId) return "/tournaments";
    return `/tournaments/${props.pageId}${
      props.secondaryId ? `/${props.secondaryId}` : ""
    }`.replace(/ /g, "_");
  };
  return (
    <Link
      to={getLinkTo()}
      onClick={() => window.scrollTo(0, 0)}
      state={props.navigateState}
      style={props.style}
      className={className}
      rel={isDead ? "nofollow" : undefined}
    >
      {text}
    </Link>
  );
}

export const TournamentPlaceContent = (props: {
  tournament: TournamentSummary;
  index: number;
}) => {
  const place = props.tournament.topThree[props.index];
  if (!place) return null;
  return (
    <TournamentLink
      pageId={typeof place === "string" ? place : place.teamId}
      text={typeof place === "string" ? place : place.teamName}
      navigateState={{
        alternatePage: {
          pageId: props.tournament.pageId,
          secondaryId: props.tournament.secondaryId,
        },
        tournamentSelectedTeam:
          typeof place === "string" ? place : place.teamName,
      }}
    />
  );
};
